<template>
    <div class="mt-3">
        <div class="table-div">
        <h3 class="bg-black text-white pt-2 pb-2 pl-3">Shift Pagi</h3>
        <table class="table table-border">
            <thead>
                <th>TIME</th>
                <th v-for="index in monthLength">{{index}}</th>
                <th>Total</th>
            </thead>
            <tbody>
                <tr v-for="(header, index) in firstRowHeader">
                    <td :class="{'bg-red bold text-white' : header == 'Total'}">{{header}}</td>
                    <td v-for="(dat, ind) in data" :class="{'bg-green' : (ind == currDate && filter.month == currMonth && filter.year == currYear)}">{{dat[variableHeader[index]]}}</td>
                    <td>{{totalPerHour[variableHeader[index]]}}</td>
                </tr>
                <tr class="bg-blue bold text-white">
                    <td>Total Pagi</td>
                    <td v-for="dat in data"> {{dat.total_pagi}}</td>
                    <td>{{overallTotal.pagi}}</td>
                </tr>
            </tbody>
        </table>
        <hr>
        </div>
        <div class="table-div">
            <h3 class="mt-3 bg-black text-white pt-2 pb-2 pl-3">Shift Malam</h3>
            <table class="table table-border">
                <thead>
                    <th>TIME</th>
                    <th v-for="index in monthLength">{{index}}</th>
                    <th>Total</th>
                </thead>
                <tbody>
                    <tr v-for="(header, index) in nightRowHeader">
                        <td>{{header}}</td>
                        <td v-for="(dat, ind) in data" :class="{'bg-green' : (ind == currDate && filter.month == currMonth && filter.year == currYear)}">{{dat[variableHeaderNight[index]]}}</td>
                        <td>{{totalPerHour[variableHeaderNight[index]]}}</td>
                    </tr>
                    <tr class="bg-red bold text-white">
                        <td >Total Malam</td>
                        <td v-for="dat in data"> {{dat.total_malam}}</td>
                        <td>{{overallTotal.malam}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- <div class="table-div">
            <table class="table table-border">
                <thead>
                    <th>TIME</th>
                    <th v-for="index in monthLength">{{index}}</th>
                    <th>Total</th>
                </thead>
                <tbody>
                    <tr class="bg-cyan bold text-white">
                        <td >Total Harian</td>
                        <td v-for="dat in data"> {{dat.total}}</td>
                        <td>{{overallTotal.all}}</td>
                    </tr>
                </tbody>
            </table>
        </div> -->

        <!-- Vehicle Type by Day -->
        <div class="table-div">
            <h3 class="bg-black text-white pt-2 pb-2 pl-3">Summary Vehicle</h3>
            <table class="table table-border">
                <thead>
                    <th>TYPE</th>
                    <th v-for="index in monthLength" v-bind:key="index">{{index}}</th>
                    <!-- <th>Total</th> -->
                </thead>
                <tbody>
                    <tr v-for="(header, index) in anotherData.vehicleTypeByDay" v-bind:key="index">
                        <td :class="{'bg-red bold text-white' : header == 'Total'}">{{header.name ? header.name : "No Name"}}</td>
                        <td v-for="(dat, ind) in header.mapped" :class="{'bg-green' : (ind == currDate && filter.month == currMonth && filter.year == currYear)}">{{dat}}</td>
                        <!-- <td>{{totalPerHour[variableHeader[index]]}}</td> The one on the right -->
                    </tr>
                    <!--<tr class="bg-blue bold text-white"> <!-- The one at the bottom
                        <td>Total</td>
                        <td v-for="dat in count"> {{dat.total_pagi}}</td>
                        <td>{{overallTotal.pagi}}</td>
                    </tr> -->
                </tbody>
            </table>
            <div v-if="!anotherData.vehicleTypeByDay" class="no-data">
                <p>No Data Available</p>
            </div>
            <hr>
        </div>

    </div>
</template>

<script>
export default {
    data(){

        var firstRowHeader = [
            '06:30 - 09:00',
            '09:00 - 10:00',
            '10:00 - 11:00',
            '11:00 - 12:00',
            '12:00 - 13:00',
            '13:00 - 14:00',
            '14:00 - 15:00',
            '15:00 - 16:30',
            '16:30 - 20:29',
        ]

        var nightRowHeader = [
            '20:30 - 22:00',
            '22:00 - 23:00',
            '23:00 - 00:00',
            '00:00 - 01:00',
            '01:00 - 02:00',
            '02:00 - 03:00',
            '03:00 - 04:30',
            '04:30 - 06:29',
        ]
        
        var variableHeader = [
            'jam_0630_09',
            'jam_09_10',
            'jam_10_11',
            'jam_11_12',
            'jam_12_13',
            'jam_13_14',
            'jam_14_15',
            'jam_15_1630',
            'jam_1630_OT',
        ]

        var variableHeaderNight = [
            'jam_2030_22',
            'jam_22_23',
            'jam_23_24',
            'jam_00_01',
            'jam_01_02',
            'jam_02_03',
            'jam_03_0430',
            'jam_0430_OT',
        ]
        var now = new Date();
        var currDate = now.getDate() - 1;
        var currMonth = now.getMonth();
        var currYear = now.getFullYear();
        var monthLength = new Date(currYear , currMonth + 1 , 0).getDate();


        return {
            firstRowHeader : firstRowHeader,
            nightRowHeader : nightRowHeader,
            variableHeader : variableHeader,
            variableHeaderNight : variableHeaderNight,
            currDate : currDate,
            currMonth : currMonth,
            currYear : currYear,
            totalPerHour : {},
            monthLength : monthLength,
            overallTotal : {
                "pagi" : 0,
                "malam" : 0,
                "all" : 0,
            }
        }
    },
    props : ['data', 'anotherData', 'filter'],
    watch:{
        data : function(){
            this.calcTotalPerHour();
            this.monthLength = new Date(this.filter.year , this.filter.month + 1 , 0).getDate()
        },
    },
    methods:{
        // Chain Function calcTotalPerHour() -> calcOverallTotal() -> calcVehicleTypeByDayTotal()
        calcTotalPerHour(){
            var headers = this.variableHeader.concat(this.variableHeaderNight)
            
            //Set Everything to 0
            for(var i = 0; i < headers.length; i++){
                this.totalPerHour[headers[i]] = 0
            }

            for(var i = 0; i < this.data.length; i++){
                for(var j = 0; j < headers.length; j++){
                    this.totalPerHour[headers[j]] += parseInt(this.data[i][headers[j]])//ADDS TOTAL
                }
            }

            this.calcOverallTotal();
        },
        calcOverallTotal(){
            this.overallTotal.pagi = 0;
            this.overallTotal.malam = 0;

            for(var i = 0; i < this.data.length; i++){
                this.overallTotal.pagi += parseInt(this.data[i].total_pagi)
                this.overallTotal.malam += parseInt(this.data[i].total_malam)
            }
            this.overallTotal.all = this.overallTotal.pagi + this.overallTotal.malam

            // this.calcVehicleTypeByDayTotal();
        },
        calcVehicleTypeByDayTotal() { // Currently not used
            // if(!this.data.vehicleTypeByDay && !this.data.vehicleTypeByDay[0]) {console.log("NO");return}
            if(!this.data.vehicleTypeByDay) return
            let count = new Array(this.data.vehicleTypeByDay[0].mapped.length).fill(0);
            for(let i = 0; i < this.data.vehicleTypeByDay[0].mapped.length; ++i) {
                for(let j = 0; j < this.data.vehicleTypeByDay.length; ++j) {
                    count[i] += this.data.vehicleTypeByDay[j].mapped[i];
                }
            }
            console.log("HASIL")
            console.log(count)
            this.$forceUpdate()
        }
    }
}
</script>

<style scoped>
    .table-div{
        display: block;
        overflow: scroll;
    }
    .bold{
        font-weight: bold;
    }
    .no-data {
        text-align: center;
        /* width: 100%; */
    }
</style>